<h2 mat-dialog-title class="dialog-title">
  {{ data?.mode === 'create' ? 'Neues Produkt' : 'Produkt bearbeiten' }}
</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <div *ngIf="loading" class="loading-container">
    <p>Lade Daten...</p>
  </div>

  <form [formGroup]="frmArtikel" *ngIf="!loading">

    <!-- Nummer (read-only, edit mode only) -->
    <div class="form-group" *ngIf="data?.mode !== 'create'">
      <label class="form-label text-xs font-medium text-gray-500 uppercase tracking-wider">Nummer</label>
      <div class="bg-gray-100 border border-gray-200 text-gray-600 text-sm rounded-lg block w-full p-2.5 font-mono select-all">
        {{ artikel.nummer }}
      </div>
    </div>

    <!-- Beschreibung -->
    <div class="form-group">
      <label class="form-label" for="beschreibung">Beschreibung *</label>
      <input
        type="text"
        id="beschreibung"
        formControlName="beschreibung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Beschreibung" />
    </div>

    <!-- Basiseinheit -->
    <div class="form-group">
      <label class="form-label" for="basiseinheit">Basiseinheit</label>
      <select
        id="basiseinheit"
        formControlName="basiseinheit"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let be of basiseinheiten" [value]="be.code">{{ be.beschreibung }} ({{ be.code }})</option>
      </select>
    </div>

    <!-- Ausbringung -->
    <div class="form-group">
      <label class="form-label" for="ausbringung">Ausbringung</label>
      <select
        id="ausbringung"
        formControlName="ausbringung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let a of ausbringungen" [value]="a.code">{{ a.beschreibung }} ({{ a.code }})</option>
      </select>
    </div>

    <!-- Sortierung -->
    <div class="form-group">
      <label class="form-label" for="sortierung">Sortierung</label>
      <input
        type="number"
        id="sortierung"
        formControlName="sortierung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Sortierung" />
    </div>

    <!-- Systemkomponente -->
    <div class="form-group">
      <label class="form-label" for="systemkomponente">Systemkomponente</label>
      <select
        id="systemkomponente"
        formControlName="systemkomponente"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let sk of systemkomponentenOptions" [value]="sk.value">{{ sk.label }}</option>
      </select>
    </div>

    <!-- Zulassungs Nummer -->
    <div class="form-group">
      <label class="form-label" for="zulassungs_nummer">Zulassungsnummer</label>
      <input
        type="text"
        id="zulassungs_nummer"
        formControlName="zulassungs_nummer"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Zulassungsnummer" />
    </div>

    <!-- Wirkstoff -->
    <div class="form-group">
      <label class="form-label" for="wirkstoff">Wirkstoff</label>
      <input
        type="text"
        id="wirkstoff"
        formControlName="wirkstoff"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Wirkstoff" />
    </div>

    <!-- Status -->
    <div class="form-group">
      <label class="form-label" for="status_id">Status</label>
      <select
        id="status_id"
        formControlName="status_id"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let s of statusOptions" [value]="s.id">{{ s.label }}</option>
      </select>
    </div>

    <!-- Biozid Produktart -->
    <div class="form-group">
      <label class="form-label" for="biozid_produktart">Biozid Produktart</label>
      <select
        id="biozid_produktart"
        formControlName="biozid_produktart"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let bp of biozidProduktartenOptions" [value]="bp.value">{{ bp.label }}</option>
      </select>
    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 16px 24px;">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button mat-button (click)="onConfirm()" [disabled]="isSubmitting" cdkFocusInitial>Speichern</button>
</mat-dialog-actions>
